import React from "react";
import SideBar from "./SideBar";
import Header from "./Header";
import Poducts from "./Poducts";
import Brands from "./Brands"
import { NavLink } from "react-router-dom";
import "../styles/Shop.css"

function Shop() {
  return (
    <>
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-3">
            <SideBar />
          </div>
          <div className="col-lg-9">
            <Header />
            <Poducts />
            <div div="row">
              <ul className="pagination pagination-lg justify-content-end">
                <li className="page-item disabled">
                  <NavLink
                    className="page-link active rounded-0 mr-3 shadow-sm border-top-0 border-left-0"
                    to="/shop"
                    tabindex="-1"
                  >
                    1
                  </NavLink>
                </li>
                <li className="page-item">
                  <NavLink
                    className="page-link rounded-0 mr-3 shadow-sm border-top-0 border-left-0 text-dark"
                    to="/shop"
                  >
                    2
                  </NavLink>
                </li>
                <li className="page-item">
                  <NavLink
                    className="page-link rounded-0 shadow-sm border-top-0 border-left-0 text-dark"
                    to="/shop"
                  >
                    3
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Brands />
    </>
  );
}

export default Shop;
